import React from "react";
import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import Process from "@/components/site/Process";
import DirectAdvantage from "@/components/site/DirectAdvantage";
import Pricing from "@/components/site/Pricing";
import About from "@/components/site/About";
import Compliance from "@/components/site/Compliance";
import Testimonials from "@/components/site/Testimonials";
import FAQ from "@/components/site/FAQ";
import Booking from "@/components/site/Booking";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";

const Landing = () => {
  return (
    <main data-testid="landing-page" className="bg-white text-[#0A0A0A] min-h-screen">
      <Navigation />
      <Hero />
      <Services />
      <Process />
      <DirectAdvantage />
      <Pricing />
      <About />
      <Compliance />
      <Testimonials />
      <FAQ />
      <Booking />
      <FinalCTA />
      <Footer />
    </main>
  );
};

export default Landing;
